<woo-modal-layout size="medium" (close)="close()" [centerTitle]="true" [closable]="false">
    <h3 header class="text-align--center">{{ content().message }}</h3>
    <dot-loader></dot-loader>
    @if(content().progress() !== null && content().progress() !== undefined) {
        <woo-progress-bar [progress]="content().progress()"></woo-progress-bar>
    }
    @if(content().progress_message()) {
        <h3 class="text-align--center">{{ content().progress_message() }}</h3>
    }
</woo-modal-layout>